var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-modal",
    {
      attrs: { "aria-label": "Finish", role: "dialog", size: "lg" },
      on: { hide: _vm.close },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("basic-modal-close-button", { ref: "closeButton" }),
          _vm._v(" "),
          _c("h3", { staticClass: "modal-title" }, [
            _vm._v("Finish " + _vm._s(_vm._f("customTerm")("Goal"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c("div", { staticClass: "form-group form-labels" }, [
            _c("label", { attrs: { for: "impact-textarea" } }, [
              _vm._v("Before you finish..."),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "textarea-description" }, [
              _vm._v(
                "Say something about how this Goal has helped you, or the person you\n                    are supporting.\n                    What's different or better now?"
              ),
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.impactText,
                  expression: "impactText",
                },
              ],
              staticClass: "form-control",
              attrs: { id: "impact-textarea", rows: "4" },
              domProps: { value: _vm.impactText },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.impactText = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-mm btn-green save-button",
                on: { click: _vm.ok },
              },
              [_vm._v("\n                    Next\n                ")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }